import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import { OpalApiRequestBody, OpalApiRequestParams } from '../../schema'

type RewindWorkflowParams = OpalApiRequestParams<'RewindWorkflowV2'>
type RewindWorkflowRequestBody = OpalApiRequestBody<'RewindWorkflowV2'>

export const rewindWorkflow = async ({
  params,
  requestBody,
}: {
  params: RewindWorkflowParams
  requestBody: RewindWorkflowRequestBody
}) => {
  const url = new URL(
    `/workflows/v2/workflows/${params.path.workflow_id}/rewind`,
    window.location.origin
  )

  url.search = queryString(params.query)

  return HttpClient()
    .patch(url.toString(), requestBody)
    .then((res) => res.data)
}
